// Host + build-flag detection for the standalone consultant app.
//
// ⚠️ THIS IS THE THIRD SHELL OVER ONE ENGINE, AND THE FIRST THAT IS CONSULTANT-
// ONLY. /clara is DVAuction Markets — market panels with Ask as the landing tab.
// /app is the Platform in app form, consultant-first but carrying markets,
// sales, barns and alerts. Both are consultant-FIRST. Neither is consultant-only,
// and stripping either would destroy the product it actually is.
//
// What makes a third shell defensible rather than sprawl: it adds no engine, no
// chat, no history and no controls. Every one of those is imported from the same
// place the other two use, so a fix reaches all three. It is a frame and a front
// door, nothing else.
//
// ⚠️ IT ALSO MOUNTS AT /ask ON EVERY HOST, not only on its own domain. A shell
// reachable only once DNS exists is a shell nobody can look at, and this one has
// to be judged by eye.

/** The dedicated domain. The app owns the root here. */
export const CONSULTANT_APP_HOSTS = ["ask.raisedbeef.com"];

export function isConsultantAppHost(): boolean {
  // Native store builds have no hostname to read — the Capacitor flavour sets
  // VITE_CONSULTANT_APP at build time, the same pattern VITE_BARN_APP and
  // VITE_DVAUCTION_APP already use.
  const built = (import.meta.env?.VITE_CONSULTANT_APP as string | undefined)?.trim();
  if (built && built !== "0" && built !== "false") return true;
  return (
    typeof window !== "undefined" &&
    CONSULTANT_APP_HOSTS.includes(window.location.hostname)
  );
}

/** "/" on the app's own domain, "/ask" everywhere else. */
export const CONSULTANT_APP_BASE = isConsultantAppHost() ? "" : "/ask";

export function consultantAppPath(path = ""): string {
  const clean = path.replace(/^\/+/, "");
  const base = CONSULTANT_APP_BASE || "/";
  if (!clean) return base;
  return base === "/" ? `/${clean}` : `${base}/${clean}`;
}
